const FinancialAccountTypes = {
  NotReported: 0,
  Depository: 1,
  Custodial: 2,
  CashValueInsuranceOrAnnuityContract: 3,
  EquityAndDebtInterests: 4,

  getDescription(type) {
    switch (type) {
      case FinancialAccountTypes.NotReported:
        return 'Not Reported';
      case FinancialAccountTypes.Depository:
        return 'Depository';
      case FinancialAccountTypes.Custodial:
        return 'Custodial';
      case FinancialAccountTypes.CashValueInsuranceOrAnnuityContract:
        return 'Cash Value Insurance Or Annuity Contract';
      case FinancialAccountTypes.EquityAndDebtInterests:
        return 'Equity and Debt Interests';
      default:
        return 'Not Reported';
    }
  }
};

export default FinancialAccountTypes;
